import { DeepReadonly, IFinance } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export * from './restrictedCountryBanks';
export * from './currencies';

interface FundingSource {
  id: string;
  label: string;
  button: string;
  buttonAlt: string;
  saveButtonText: string;
}

export const defaultFinance: DeepReadonly<IFinance> = deepFreeze({
  courseFeeDepositReqd: '',
  courseFeeDeposit: undefined,
  courseFeeDepositDate: '',
  courseFeeDepositNotReqdReason: '',
  accomDepositReqd: '',
  accomDeposit: 0,
  accomDepositDate: '',
  organisationSponsorship: {},
  scholarshipSponsorship: {},
  educationSponsorship: {},
  familySponsorship: {},
  otherSponsorship: {},
  fundingSummary: {
    courseFees: [],
    studentLivingCost: {
      label: '',
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    spouseLivingCost: {
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    childrenLivingCost: {
      number: 0,
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    totalToBeShown: 0,
    totalRemaining: 0,
    totalInvalid: 0
  },
  isSectionStarted: false,
  isSectionComplete: false
});

export const fundingSources: DeepReadonly<FundingSource[]> = deepFreeze([
  {
    id: 'organisationSponsorship',
    label: 'Company or Government Sponsorship',
    button: 'Add Sponsorship',
    buttonAlt: 'Add another Sponsorship',
    saveButtonText: 'Save Sponsorship Details'
  },
  {
    id: 'scholarshipSponsorship',
    label: 'University Scholarship or Discount',
    button: 'Add Scholarship',
    buttonAlt: 'Add another scholarship',
    saveButtonText: 'Save Scholarship Details'
  },
  {
    id: 'educationSponsorship',
    label: 'Education Loan',
    button: 'Add Loan',
    buttonAlt: 'Add another loan',
    saveButtonText: 'Save Loan Details'
  },
  {
    id: 'familySponsorship',
    label: 'Myself or My Family',
    button: 'Add Bank Account',
    buttonAlt: 'Add another bank account',
    saveButtonText: 'Save Funding Details'
  },
  {
    id: 'otherSponsorship',
    label: 'Other',
    button: 'Add Other',
    buttonAlt: 'Add another Other',
    saveButtonText: 'Save Other Details'
  }
]);
